import { fetchDropDownList, fetchDropDownListByDictType } from '@/api/common'
import { fetchCommonPorts } from '@/api/dict'

type State = {
  product: {
    domain: string
    productCode: string
    formListCode: string
    promptCode: {
      partyOnly: string
      houseBill: string
    }
  }
  dropdown: Partial<Record<string, Dict[]>>
  dropdowMap: {
    [key: string]: { [key: string]: Dict }
  }
}
/**
 * @description:基础信息
 * @return {*}
 */
const useBaseStore = defineStore('base', {
  state: (): State => {
    return {
      product: {
        /** 二级域名匹配的产品 */
        domain: '',
        /** 产品代码 */
        productCode: '',
        /** 表单代码 */
        formListCode: '',
        /** ai提示代码 */
        promptCode: {
          partyOnly: 'AMS_MEXICO_PARTY_ONLY',
          houseBill: 'AMS_MEXICO_HOUSE_BILL',
        },
      },
      dropdown: {},
      dropdowMap: {},
    }
  },
  getters: {
    /** 产品代码 */
    getProductCode: (state) =>
      state.product.productCode || 'product_ams_mexico',
    /** 表单代码 */
    getFormListCode: (state) =>
      state.product.formListCode || 'AMS_MEXICO-pageListInfo',
    /** 二级域名匹配的产品 */
    getDomain: (state) => state.product.domain || 'mexico',
    /** ai提示代码 */
    getPromptCode: (state) =>
      state.product.promptCode || {
        partyOnly: 'AMS_MEXICO_PARTY_ONLY',
        houseBill: 'AMS_MEXICO_HOUSE_BILL',
      },
  },
  actions: {
    async getDropDownListByDictType(dictType: string) {
      const data = await fetchDropDownListByDictType(dictType)
      this.dropdown[dictType] = data
      return data
    },
    async getDropDownList() {
      const data = await fetchDropDownList()
      Object.keys(data).forEach((key) => {
        const value: Dict[] = []
        const commonValue: Dict[] = []
        const dropdowMap: { [key: string]: Dict } = {}
        data[key as any].forEach((item: Dict) => {
          item.extend = item.extend ? JSON.parse(item.extend) : {}
          item.label = item.dictLabel
          item.value = item.dictCode
          if (item.tag !== 'common') {
            value.push(item)
          } else {
            commonValue.push(item)
          }
          dropdowMap[item.dictValue] = item
        })
        this.dropdown[key as any] = value
        this.dropdown[`${key}_common` as any] = commonValue
        this.dropdowMap[key as any] = dropdowMap
      })

      const AMS_MEXICO_PORT_LOADING = await fetchCommonPorts(
        'AMS_MEXICO_PORT_LOADING',
      )
      this.dropdown['AMS_MEXICO_PORT_LOADING'] = AMS_MEXICO_PORT_LOADING
      const AMS_MEXICO_PORT_DISCHARGE = await fetchCommonPorts(
        'AMS_MEXICO_PORT_DISCHARGE',
      )
      this.dropdown['AMS_MEXICO_PORT_DISCHARGE'] = AMS_MEXICO_PORT_DISCHARGE
    },
  },
})

export default useBaseStore
